const routesConstants = {
  LOGIN: "admin/login",
  CUSTOMERS: "admin/customers",
  RETAILERS: "admin/retailers",
  PRODUCTS: "admin/products",
  CATEGORY: "admin/category",
  ORDERS: "admin/orders",
  REFERRAL: "admin/referral",
  ANALYTICS: "admin/analytics",
  PRIVACY: "privacy-policy",
  TERMSANDCONDITION: "terms-condition",
  RETURN_POLICY: "return-policy",
  HOME: "/",
};

export default routesConstants;
